import type { Step as RcStep } from '@sb/remote-control/types';

import { type ValidationRule } from '../../types';
import { ActionRequiredError } from '../../util/errors';

import { CanonicalStepRuleBase } from './base';
import type { CanonicalValidateArgs } from './base';

class TriggerFaultRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.TriggerFault', 'TriggerFault');
  }

  protected validate({ args }: CanonicalValidateArgs): void {
    type TFArgs = Extract<RcStep.Arguments, { argumentKind: 'TriggerFault' }>;
    const a = args as TFArgs;

    if (a?.argumentKind !== 'TriggerFault') {
      throw new TypeError(`Expected argument kind TriggerFault`);
    }

    if (!a.message) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'Message is not configured',
        fieldId: 'message',
      });
    }
  }
}

export const TriggerFaultValidation: ValidationRule =
  new TriggerFaultRule().toValidationRule();
